export const required = "Обязательное поле",
  requiredCeck = "Подтвердите свое согласие",
  valid = "Данные не корректны",
  nameMin = "Минимальное количество 2 символа",
  ageMin = "Минимальное количество 10 символов",
  nameMax = "Максимальное количество 50 символов",
  passwordMax = "Максимальное количество 14 символов",
  passwordMin = "Минимальное количество 8 символов",
  confrmPasswordMatch = "Пароли не совпадают";
